import React from 'react';
import localization from '../../../services/Localization';

const Footer = () => {
  const { onboarding: lang } = localization;
  return <div className="realm-onboarding--footer">{lang.footer}</div>;
};

export default Footer;
